import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { paths } from '../paths';

const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  SignUpPage: lazy(() => import('src/pages/auth/jwt/sign-up')),
};

export const authRoutes: RouteObject[] = [
  {
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: paths.auth.signIn,
        element: (
          <GuestGuard>
            <Jwt.SignInPage />
          </GuestGuard>
        ),
      },
      {
        path: paths.auth.signUp,
        element: (
          <GuestGuard>
            <Jwt.SignUpPage />
          </GuestGuard>
        ),
      },
    ],
  },
];
